// src/components/ProtectedRoute.tsx
import { useAppManager } from "@/context/AppManagerContext";
import { Navigate, Outlet } from "react-router-dom";
import React from "react";

const ProtectedRoute: React.FC = () => {
  const { currentOrganization } = useAppManager();

  if (!currentOrganization) {
    return <Navigate to="/organizacoes" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
